/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import CloseAction from './CloseAction/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import PreviewResource from 'DesignSystem/PreviewResource/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Images/Videos/Preview/Content/Content"
  
}) {
let selectedFileNameValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'file_name',
})
let selectedValueData = fromData.useDataValue({ viewPath,
context: 'selected',
})
let onUploadCaptures = fromHelpers.useOnUploadCaptures({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 width="auto"
 height="auto"
 maxWidth="90%"
 maxHeight="90%"
 overflow="auto"
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 data="selected.file_name"
 text={selectedFileNameValueData}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<PreviewResource
{...childProps}
  viewPath={`${viewPath}/PreviewResource`}
 height="90%"
 data="selected"
 resource={selectedValueData}
 onUploadCaptures={onUploadCaptures}
/>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}